import React from 'react';
import { Container, Section } from 'react-bulma-components';
import { usePageTitle } from '../../hooks/usePageTitle';
import styles from './ContactUs.module.scss';
import SupportEmailLink from '../../components/SupportEmailLink/SupportEmailLink';
import DiscordInviteButton from '../../components/DiscordInviteButton/DiscordInviteButton';

const ContactUs: React.FC = () => {
  usePageTitle({
    title: 'Contact Us | Connect with OnePlay Team',
    description: 'Reach out to OnePlay support team'
  });

  const handleEmailCopy = () => {
    navigator.clipboard.writeText('support@oneplay.in');
    // You can add a toast notification here if needed
  };

  return (
    <Section className={styles.contactUsSection}>
      <Container>
        <div className={styles.content}>
          <h1 className={styles.title}>Your voice matters</h1>
          
          <div className={styles.description}>
            <p>
              We are always here to listen. Let's enhance our community together.
            </p>
          </div>

          <div className={styles.section}>
            <h2 className={styles.sectionTitle}>Need help with OnePlay?</h2>
            <p className={styles.sectionContent}>
              Please provide your information to help us contact you
            </p>
            <div className={styles.contactLinkContainer}>
              <a 
                href="https://www.oneplay.in/contact.html" 
                target="_blank"
                rel="noopener noreferrer"
                className={styles.contactLinkButton}
              >
                <span className={styles.contactLinkIcon}>📧</span>
                <span className={styles.contactLinkText}>Go to Contact Form</span>
                <span className={styles.contactLinkArrow}>→</span>
              </a>
            </div>
          </div>

          <div className={styles.divider}>
            <div className={styles.dividerLine}></div>
            <span className={styles.dividerText}>OR</span>
            <div className={styles.dividerLine}></div>
          </div>

          <div className={styles.section}>
            <h2 className={styles.sectionTitle}>Drop us an email</h2>
            <div className={styles.emailContainer}>
              <a 
                href="mailto:support@oneplay.in" 
                className={styles.emailLink}
                id="emailId"
              >
                support@oneplay.in
              </a>
              <button 
                className={styles.copyButton}
                onClick={handleEmailCopy}
                aria-label="Copy email"
              >
                <i className="fa-solid fa-copy"></i>
              </button>
            </div>
          </div>

          <div className={styles.section}>
            <div className={styles.stepContent}>
              <h3 className={styles.stepTitle}>OnePlay Support</h3>
              <div className={styles.stepDescription}>
                <div style={{ marginBottom: '12px' }}>
                  For any assistance please contact us via email at <SupportEmailLink /> or join our Discord channel:
                </div>
                <DiscordInviteButton />
              </div>
            </div>
          </div>
        </div>
      </Container>
    </Section>
  );
};

export default ContactUs;

